import React, {Component} from "react";
import BaseBtn from "../../Buttons/BaseBtn";
import * as AdminHomeworkService from "../../../services/Teacher/AdminHomeworkService";
import Loading from "../Loading/index";

class PopupVocabUpload extends Component {
    state = {
        visible: false,
        file: undefined,

        // loading
        isLoadingHide: true
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            visible: nextProps.active
        });
    }

    closePopup = () => {
        const {mode, onSubmit} = this.props;
        if (this.state.visible) {
            this.setState({
                visible: false,
                isLoadingHide: true
            });
        }
    }

    onHandleSubmit = (event) => {
        if (this.state.file == null || this.state.file == undefined || this.state.file == '') {
            alert('저장할 단어가 없습니다');
            return false;
        }

        alert('서버에서 TTS 단어를 저장을 시작 합니다...');
        let formData = new FormData();
        formData.append('file', this.state.file, this.state.file.name);
        const that = this;
        AdminHomeworkService.saveVocabulary(formData).then((response) => {
            console.log('TTS FILE SAVE REQUESTED (response) : ' + response);
            that.closePopup();
        });
        /** 2021-02-21 response를 기다리는 것보다 background 로 돌아가는게 맞다고 생각되어 위와 같이 수정함 */
        //     .then((response) => {
        //     if (response.status === 200) {
        //         let responseData = response.data;
        //         if (responseData.code === '0000') {
        //             alert('단어 저장 성공');
        //             this.props.onSubmit(responseData.data);
        //             this.closePopup();
        //         } else {
        //             alert(responseData.data);
        //         }
        //     } else {
        //         alert('GET HOMEWORK ERROR');
        //     }
        //     that.setState({
        //         isLoadingHide: true
        //     });
        // }).catch(response => {
        //     alert("SERVER ERROR" + response);
        //     that.setState({
        //         isLoadingHide: true
        //     });
        // });
    }

    onHandleChange = (event) => {
        let file = event.target.files[0];
        this.setState({file: file});
    };


    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return (
            this.state.visible ?
                <div className="popupWrapper">
                    <div className="popup">
                        <div className="alertWrapper">
                            <dl className="alert">
                                <dt className="title">
                                    <span>알림</span>
                                    <button onClick={this.closePopup} className="btnClose">닫기</button>
                                </dt>
                                <dd className="contents">
                                    <div>
                                        {/*<div className="desc">
                                         <span>{this.props.message}</span>
                                         </div>*/}
                                        <div className="desc">
                                            {/*<a className="baseBtn blue" onClick={this.uploadExcel}><span>엑셀파일 업로드</span></a>*/}
                                            <input type="file" onChange={this.onHandleChange}/>
                                            {/*<a className="baseBtn blue" onClick={this.uploadFile}><span>파일 업로드</span></a>*/}
                                        </div>
                                        {/*<div className="desc">
                                         <span>정말로 삭제하시겠습니까?</span>
                                         </div>*/}
                                        <BaseBtn btnColor="deepPink" btnName={this.props.confirmName}
                                                 onClick={this.onHandleSubmit}/>
                                    </div>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
                : null
        );
    }
}

PopupVocabUpload.defaultProps = {
    active: true,
    onSubmit: () => {
    },
    confirmName: "단어 저장"
}
export default PopupVocabUpload;


// WEBPACK FOOTER //
// ./src/components/Containers/PopupVocabUpload/index.js